var _circle, _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _path2, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPostbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 256,
    viewBox: "0 0 286 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 127.896,
    cy: 127.896,
    r: 127.896,
    fill: "#5296D5",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.91 69.673H286L265.773 61.7667L198.895 53.1074L157.626 57.8136L136.91 69.673Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.656,
    cy: 57.0051,
    rx: 11.7925,
    ry: 10.2317,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.872,
    cy: 55.7878,
    rx: 11.7925,
    ry: 10.4753,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 252.096,
    cy: 53.1078,
    rx: 17.0569,
    ry: 15.1039,
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 230.618,
    cy: 56.275,
    rx: 12.4242,
    ry: 10.9625,
    fill: "white"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 156.072,
    cy: 59.9285,
    rx: 7.79144,
    ry: 6.82112,
    fill: "white"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 269.154,
    cy: 62.8524,
    rx: 7.58086,
    ry: 6.82112,
    fill: "white"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 215.456,
    cy: 47.9918,
    rx: 12.4242,
    ry: 10.9625,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.753 45.3117H14.1294L26.4241 37.4054L67.0758 28.7461L92.1608 33.4522L104.753 45.3117Z",
    fill: "white"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.52641,
    cy: 6.57751,
    rx: 8.52641,
    ry: 6.57751,
    transform: "matrix(-1 0 0 1 101.342 31.6699)",
    fill: "white"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.1295,
    cy: 9.01363,
    rx: 14.1295,
    ry: 9.01363,
    transform: "matrix(-1 0 0 1 68.2114 22.9004)",
    fill: "white"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.3731,
    cy: 10.9625,
    rx: 14.3731,
    ry: 10.9625,
    transform: "matrix(-1 0 0 1 92.5723 20.9512)",
    fill: "white"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.77002,
    cy: 6.82112,
    rx: 8.77002,
    ry: 6.82112,
    transform: "matrix(-1 0 0 1 42.3882 31.6699)",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 121.318,
    y: 112.061,
    width: 17.54,
    height: 139.833,
    fill: "#144C8C",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4414 84.5338C56.4223 69.8156 67.6661 56.0312 82.6908 56.0312H154.222C169.686 56.0312 182.222 68.5673 182.222 84.0313V112.062L59.4414 112.062V84.5338Z",
    fill: "#A9BFD6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M167.361 61.146C164.842 59.4302 163.177 58.4132 159.863 57.413C157.43 56.6788 153.475 55.9585 153.475 55.9585C169.283 55.73 182.221 68.4821 182.221 84.2921V112.061H179.519C179.519 112.061 179.519 94.2159 179.519 85.4765C179.519 76.7372 178.857 77.2599 176.618 71.8649C174.533 66.8411 171.918 64.2495 167.361 61.146Z",
    fill: "#091F38",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.853 77.657C58.6408 65.7764 68.2135 56.0312 80.096 56.0312C91.8301 56.0312 101.342 65.5436 101.342 77.2777V110.6H59.4412L58.853 77.657Z",
    fill: "#091F38",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8774 76.7386C61.8774 66.3787 70.2757 57.9805 80.6355 57.9805C90.9953 57.9805 99.3936 66.3787 99.3936 76.7386V110.601H61.8774V76.7386Z",
    fill: "#1762B6",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8771 74.3C62.8658 69.1355 64.3204 65.6028 68.4546 62.1194C71.9133 59.2053 74.66 58.0235 79.1735 57.7344C83.4795 57.4586 86.0744 58.4042 89.8924 60.4142C94.5211 62.8509 96.7136 67.2348 96.7136 67.2348C96.7136 67.2348 89.4116 64.6979 84.777 65.5307C78.7778 66.6086 74.9512 68.454 71.8656 74.3C65.4008 86.5482 61.8772 110.598 61.8772 110.598C61.8772 110.598 59.685 85.7504 61.8771 74.3Z",
    fill: "#0D3563",
    fillOpacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.97 255.08C137.506 255.551 132.973 255.793 128.383 255.793C124.671 255.793 120.996 255.635 117.364 255.325L117.283 254.72C117.204 254.131 117.116 253.545 117.019 252.961L115.982 252.147C109.366 246.957 101.595 243.029 93.1811 240.62L81.8535 237.378L91.4819 238.376C99.8265 239.241 107.873 241.561 115.162 245.154C113.872 241.029 112.124 237.064 109.949 233.335C107.989 231.161 105.87 229.113 103.606 227.21L96.0237 220.839L103.103 224.777C103.597 225.052 104.087 225.333 104.572 225.62L102.816 223.414L106.813 226.706C107.35 227.148 107.878 227.601 108.395 228.064C115.471 232.947 121.473 239.174 126.001 246.322C123.554 239.33 119.791 232.84 114.888 227.215L112.194 224.124L116.303 227.228C120.021 230.037 123.317 233.307 126.127 236.935C124.391 232.026 122.001 227.355 119.009 223.052L113.656 215.354L119.222 220.625C125.739 226.797 130.709 234.348 133.807 242.664C134.912 234.695 137.789 227.089 142.315 220.383L145.022 216.374L142.709 222.315C139.973 229.345 138.774 236.903 139.16 244.538C142.712 237.812 147.718 231.886 153.884 227.228L157.993 224.124L155.299 227.215C151.021 232.123 147.611 237.689 145.186 243.673C150.902 239.648 157.415 236.775 164.364 235.289L169.4 234.212L165.652 235.875C156.197 240.07 148.026 246.697 141.97 255.08Z",
    fill: "#A7D3CA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M160.053 71.1348L125.582 71.1348C123.765 71.1348 122.293 72.6072 122.293 74.4235C122.293 76.2399 123.765 77.7123 125.582 77.7123L143.731 77.7123L143.731 78.5181C143.731 86.1456 149.914 92.329 157.542 92.329C158.928 92.329 160.053 91.2047 160.053 89.8179L160.053 71.1348Z",
    fill: "#A7BACC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M121.318 112.061H138.858C138.858 112.061 130.874 113.47 127.165 116.689C123.936 119.492 121.318 125.946 121.318 125.946V112.061Z",
    fill: "#0D3563",
    fillOpacity: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5474 88.6738C75.5474 88.6738 77.2235 91.7908 78.9009 93.0959C80.7506 94.5351 84.4426 95.24 84.4426 95.24C84.4426 95.24 80.9389 96.1967 79.6266 97.9137C78.2515 99.713 78.0811 103.858 78.0811 103.858C78.0811 103.858 76.3256 100.064 74.327 98.7121C72.598 97.5429 69.1858 97.292 69.1858 97.292C69.1858 97.292 72.3308 95.6152 73.6012 93.8942C74.8716 92.1732 75.5474 88.6738 75.5474 88.6738Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2861 74.0586C83.2861 74.0586 83.1373 75.9361 83.5113 77.0034C83.9238 78.1805 85.372 79.5602 85.372 79.5602C85.372 79.5602 83.5289 78.978 82.4469 79.3677C81.3131 79.7761 80.0418 81.5811 80.0418 81.5811C80.0418 81.5811 80.3505 79.3777 79.8462 78.1969C79.4099 77.1755 77.9559 76.0795 77.9559 76.0795C77.9559 76.0795 79.8461 76.2362 80.9106 75.8326C81.975 75.4291 83.2861 74.0586 83.2861 74.0586Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4346 81.3672C55.4346 81.3672 56.7148 83.3568 57.901 84.1388C59.2092 85.0012 61.7067 85.2778 61.7067 85.2778C61.7067 85.2778 59.4216 86.0988 58.6369 87.3118C57.8145 88.583 57.9179 91.3545 57.9179 91.3545C57.9179 91.3545 56.5493 88.9174 55.1466 88.1213C53.9331 87.4325 51.6458 87.4439 51.6458 87.4439C51.6458 87.4439 53.6541 86.1618 54.4107 84.9483C55.1673 83.7348 55.4346 81.3672 55.4346 81.3672Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1035 98.7012C52.1035 98.7012 52.8175 100.553 53.6593 101.397C54.5876 102.328 56.5926 102.979 56.5926 102.979C56.5926 102.979 54.5758 103.266 53.7251 104.129C52.8336 105.034 52.448 107.328 52.448 107.328C52.448 107.328 51.7374 105.094 50.7201 104.201C49.84 103.429 47.9589 103.05 47.9589 103.05C47.9589 103.05 49.8266 102.338 50.6543 101.47C51.4819 100.601 52.1035 98.7012 52.1035 98.7012Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2646 88.6738C42.2646 88.6738 42.663 89.7071 43.1327 90.178C43.6506 90.6972 44.7692 91.0606 44.7692 91.0606C44.7692 91.0606 43.644 91.2204 43.1694 91.7021C42.672 92.2069 42.4568 93.4871 42.4568 93.4871C42.4568 93.4871 42.0604 92.2403 41.4928 91.7425C41.0018 91.3118 39.9523 91.1004 39.9523 91.1004C39.9523 91.1004 40.9943 90.7029 41.4561 90.2183C41.9179 89.7338 42.2646 88.6738 42.2646 88.6738Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9424 72.5957C66.9424 72.5957 66.8711 73.7008 67.1002 74.3251C67.3529 75.0136 68.2163 75.8123 68.2163 75.8123C68.2163 75.8123 67.1276 75.4859 66.4948 75.7244C65.8317 75.9743 65.0999 77.0465 65.0999 77.0465C65.0999 77.0465 65.2624 75.7484 64.9556 75.0585C64.6903 74.4617 63.826 73.8299 63.826 73.8299C63.826 73.8299 64.9387 73.9057 65.561 73.6592C66.1833 73.4128 66.9424 72.5957 66.9424 72.5957Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostbox);
export default __webpack_public_path__ + "static/media/postbox.b71f876a33b5592cbef437a03065f65f.svg";
export { ForwardRef as ReactComponent };